import React from "react"
import { Link } from "gatsby"
import { useSiteTranslations } from "@hooks/useSiteTranslations"

import * as s from "./Breadcrumbs.module.scss"

export function Breadcrumbs({ productType }) {
  const {
    shopTranslations: { shop },
  } = useSiteTranslations()

  return (
    <div className={s.breadcrumbs}>
      <Link to="/shop">{shop.breadcrumbs.shopTitle}</Link>
      <i className="fa-solid fa-play"></i>
      {productType === "Beer" ? (
        <Link to="/shop/beer">{shop.breadcrumbs.beerTitle}</Link>
      ) : (
        <Link to="/shop/merch">{shop.breadcrumbs.merchTitle}</Link>
      )}
      <i className="fa-solid fa-play"></i>
    </div>
  )
}
